import { useEffect, useState, useRef } from "react";
import UserBadge from "../../assets/images/svg-icons-material-io/badge_FILL0_wght400_GRAD0_opsz48.svg";
import SpecialtyDropdown from "../shared/SpecialtyDropdown";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";
import { stateCodeArray } from "../../services/fakeDB/ListUser";
import $ from "jquery";
import validEmail from "../../utils/emailUtils";

function getDigits(s = "") {
  return String(s).replace(/\D/g, "");
}

function isEmptyStr(s) {
  return getDigits(s).length === 0;
}

function isInvalidPhone(s) {
  const d = getDigits(s);
  return d.length > 0 && d.length < 10; // require 10 digits
}

function isInvalidPostalCode(s) {
  const d = getDigits(s);
  return d.length > 0 && d.length < 5; // require 5 digits
}
function formatPhoneNumber(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}

const EditUser = ({ closeEdit, userEditDetails }) => {
  const { SetSharedObject, userRole, userToken, sharedObject } = useUserStore(
    (state) => ({
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
    }),
  );
  const [answers, setAnswers] = useState({});
  const [processing, SetProcessing] = useState(false);
  const [flag, SetFlag] = useState(false);
  const [frmSubmFlag, SetFrmSubmFlag] = useState(false);
  const [ContactEmail, setContactEmail] = useState("");
  const [Credential, setCredential] = useState("");
  const [NamePrefix, setNamePrefix] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [UserNameDisplay, setUserNameDisplay] = useState("");
  const [Addresses, setAddresses] = useState("");
  const [specialtiesObj, setSpecialtiesObj] = useState({});
  const [specialtiesFlag, SetspecialtiesFlag] = useState(false);
  const [invalidContactEmail, setInvalidContactEmail] = useState(false);
  const setAnswer = async (questionId, answer) => {
    await setAddresses({ ...Addresses, [questionId]: answer });
  };
  const ClearFields = async () => {
    let obj = userEditDetails;
    if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
      setUpAnswers(obj);
    }
  };

  useEffect(() => {
    let obj = userEditDetails;
    if (obj && Object.keys(obj).length > 0 && obj.constructor === Object) {
      setUpAnswers(obj);
    }
    SetFlag(false);
    SetspecialtiesFlag(false);
    return () => {
      ClearFields();
      SetSharedObject("hidePermission", false);
      SetspecialtiesFlag(false);
    };
  }, [userEditDetails]);
  const setUpAnswers = async (frm) => {
    const add = await listAddress(frm.addresses);
    let editObj = {
      Addresses: await add,
      Administrator: frm.administrator,
      AllowDMEAccess: frm.allowDMEAccess,
      AllowENSAccess: frm.allowENSAccess,
      AllowFormsAccess: frm.allowFormsAccess,
      AllowPriorAuthAccess: frm.allowPriorAuthAccess,
      ClaimsAttachmentPayer: frm.claimsAttachmentPayer,
      ClaimsAttachmentProvider: frm.claimsAttachmentProvider,
      ClaimsAttachmentStaff: frm.claimsAttachmentStaff,
      ContactEmail: frm.contactEmail,
      CreateUsers: frm.createUsers,
      Credential: frm.credential ? frm.credential : "",
      DirectEmail: frm.directEmail,
      DME_Payer: frm.dmE_Payer,
      DME_Provider: frm.dmE_Provider,
      DME_Staff: frm.dmE_Staff,
      DME_Supplier: frm.dmE_Supplier,
      DomainName: frm.domainName,
      FirstName: frm.firstName,
      FullName: frm.fullName,
      HasAddresses: frm.hasAddresses,
      HasSpecialties: frm.hasSpecialties,
      Id: frm.id,
      IDs: ListIds(frm.iDs),
      IsLockedByAdmin: frm.isLockedByAdmin,
      IssueInvites: frm.issueInvites,
      LastLoginTime: frm.lastLoginTime ? frm.lastLoginTime : "",
      LastName: frm.lastName,
      LockoutEnabled: frm.lockoutEnabled,
      LockoutEndDate: frm.lockoutEndDate,
      NPI: frm.npi ? frm.npi : "",
      NamePrefix: frm.namePrefix,
      PreAuthProvider: frm.preAuthProvider,
      PreAuthReviewer: frm.preAuthReviewer,
      PreAuthStaff: frm.preAuthStaff,
      PreAuthSupervisor: frm.preAuthSupervisor,
      RegistrationStatus: frm.registrationStatus,
      RequireIdVerification: frm.requireIdVerification,
      Specialties: listSpecial(frm.specialties),
      Status: frm.status ? frm.status : "",
      TFAEmail: frm.tfaEmail ? frm.tfaEmail : "",
      TFAOn: frm.tfaOn,
      TFAPhone: frm.tfaPhone ? frm.tfaPhone : "",
      TrustedAgent: frm.trustedAgent,
      TwoFactorEnabled: frm.twoFactorEnabled,
      UserDirectEmailId: frm.userDirectEmailId,
      UserName: frm.userName,
      UserNameDisplay: frm.userNameDisplay,
      UserTypeString: frm.userTypeString,
      VendorEmailForwardingType: frm.vendorEmailForwardingType,
      VendorEmailForwardingTypeString: frm.vendorEmailForwardingTypeString,
    };
    await setAnswers(editObj);
    await SetSharedObject("editObj", editObj);
    await setContactEmail(frm.contactEmail);
    await setCredential(frm.credential);
    var namePrefix = frm.fullName.split(" ");
    namePrefix = namePrefix[0].split(".");
    await setNamePrefix(namePrefix[0]);
    await setFirstName(frm.firstName);
    await setLastName(frm.lastName);
    await setUserNameDisplay(frm.userNameDisplay);
    await setAddresses(add);
    await setSpecialtiesObj(editObj.Specialties);
  };

  const listAddress = async (frm) => {
    let address = {};
    if (frm && frm.length > 0) {
      let obj = frm[0];
      address = {
        FirstLine: obj.firstLine,
        SecondLine: obj.secondLine,
        City: obj.city,
        State: obj.state,
        PostalCode: obj.postalCode,
        Country: obj.country,
        Phone: obj.phone.substring(0, 10),
        PhoneExt: obj.phone.substring(10, obj.phone.length),
        Fax: obj?.fax?.substring(0, 10),
        FaxExt: obj?.fax?.substring(10, obj.fax.length),
        AddressType: obj.addressType,
        Id: obj.id,
      };
    } else {
      address = {
        FirstLine: "",
        SecondLine: "",
        City: "",
        State: "",
        PostalCode: "",
        Country: "USA",
        Phone: "",
        PhoneExt: "",
        Fax: "",
        FaxExt: "",
        AddressType: 0,
      };
    }
    return address;
  };
  const listSpecial = (frm) => {
    let s = [
      {
        Classification: null,
        Code: null,
        Definition: null,
        Id: null,
        Notes: null,
        Specialization: null,
        Type: null,
      },
    ];
    if (frm && frm.length > 0) {
      let obj = frm[0];
      s = [
        {
          Classification: obj.classification,
          Code: obj.code,
          Definition: obj.definition,
          Id: obj.id,
          Notes: obj.notes,
          Specialization: obj.specialization,
          Type: obj.type,
        },
      ];
    }
    return s;
  };
  const ListIds = (ob) => {
    let temp = [];
    if (ob && ob.length > 0) {
      for (let id of ob) {
        let obj = {
          RecordId: id.recordId,
          IDTypeString: id.idTypeString,
          IDType: id.idType,
          Value: id.value,
          IssuingAuthority: id.issuingAuthority,
        };
        temp.push(obj);
      }
    }

    return temp;
  };
  const CheckSpecialty = () => {
    let flag =
      isEmpty(sharedObject.specialties.Code) &&
      (!isEmpty(sharedObject.specialties.Type) ||
        !isEmpty(sharedObject.specialties.Classification));
    return flag;
  };
  function isEmpty(value) {
    let x =
      value == null || (typeof value === "string" && value.trim().length === 0);
    return x;
  }
  const updateUser = async () => {
    SetFrmSubmFlag(true);
    SetspecialtiesFlag(false);
    if (isEmpty(FirstName)) {
      document.getElementById("FirstName").scrollIntoView();
      document.getElementById("FirstName").focus();
      return;
    } else if (isEmpty(LastName)) {
      document.getElementById("LastName").scrollIntoView();
      document.getElementById("LastName").focus();
      return;
    } else if (isEmpty(ContactEmail)) {
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      return;
    } else if (isEmpty(Addresses?.FirstLine)) {
      document.getElementById("FirstLine").scrollIntoView();
      document.getElementById("FirstLine").focus();
      return;
    } else if (isEmpty(Addresses?.City)) {
      document.getElementById("City").scrollIntoView();
      document.getElementById("City").focus();
      return;
    } else if (isEmpty(Addresses?.State)) {
      document.getElementById("State").scrollIntoView();
      document.getElementById("State").focus();
      return;
    } else if (isEmpty(Addresses?.PostalCode)) {
      document.getElementById("PostalCode").scrollIntoView();
      document.getElementById("PostalCode").focus();
      return;
    } else if (isEmpty(Addresses?.Phone)) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    } else if (CheckSpecialty()) {
      SetspecialtiesFlag(true);
      return;
    } else if (isInvalidPhone(Addresses?.Phone)) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    } else if (!isEmptyStr(Addresses?.Fax) && isInvalidPhone(Addresses?.Fax)) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      return;
    } else if (isInvalidPostalCode(Addresses?.PostalCode)) {
      document.getElementById("Phone").scrollIntoView();
      document.getElementById("Phone").focus();
      return;
    } else if (!isEmptyStr(Addresses?.Fax) && isInvalidPhone(Addresses?.Fax)) {
      document.getElementById("Fax").scrollIntoView();
      document.getElementById("Fax").focus();
      return;
    }
    if (!validEmail(ContactEmail)) {
      setInvalidContactEmail(true);
      document.getElementById("ContactEmail").scrollIntoView();
      document.getElementById("ContactEmail").focus();
      return;
    }
    setInvalidContactEmail(false);
    let phone = getDigits(Addresses.Phone).slice(0, 10);
    let phonExt = Addresses.PhoneExt ? Addresses.PhoneExt : "";
    let fax = getDigits(Addresses.Fax).slice(0, 10);
    let FaxExt = Addresses.FaxExt ? Addresses.FaxExt : "";

    Addresses.Phone = `${phone}${phonExt}`;
    Addresses.Fax = `${fax}${FaxExt}`;

    let vals = {
      ...sharedObject.editObj,
      Addresses: [Addresses],
      FirstName: FirstName,
      LastName: LastName,
      ContactEmail: ContactEmail,
      Credential: Credential,
      FullName: `${FirstName} ${LastName}`,
    };
    vals.Specialties = sharedObject?.specialties?.Code
      ? [sharedObject?.specialties]
      : null;

    SetProcessing(true);
    let call =
      "/admin/UpdateUser?specializationCode=" + sharedObject?.specialties?.Code;
    const res = await CallAPI(call, vals, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      SetFlag("success");
      closeEdit(true);
      CloseModal();
    } else if (res.status === "SERVERERROR") {
      SetFlag("error");
      SetProcessing(false);
    }
  };
  const SpecialFormFields = async (val) => {
    let o = [
      {
        Type: val?.SpecialtyType,
        Code: val?.SpecialtySpecialization,
        Classification: val?.specializationCode?.classification,
        Specialization: val?.specializationCode?.specialization,
        Id: val?.specializationCode?.id,
        Notes: val?.specializationCode?.notes,
        Definition: val?.specializationCode?.definition,
      },
    ];
    await setAnswers({
      ...answers,
      Specialties: o,
      specializationCode: val.SpecialtySpecialization,
    });
    return o;
  };
  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    $("#EditAccountModal").modal("hide");
  };

  return (
    <div className="EditAccount">
      <div
        className="modal fade"
        data-backdrop="false"
        id="EditAccountModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="EditAccountTitle"
        aria-describedby="EditAccountDesc"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-slideout ">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline text-size3"
                id="EditAccountTitle"
              >
                Edit Accounts
              </h2>
              <button
                type="button"
                className="close"
                onClick={(e) => {
                  CloseModal();
                  ClearFields();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <p id="EditAccountDesc" className="sr-only">
              Edit your account details including personal information and
              contact information.
            </p>
            <form className="needs-validation" noValidate>
              <div className="modal-body">
                <div className="modal-content-body container">
                  <div className="details-header blk-clr">
                    <img src={UserBadge} alt="Medical Information Icon" />
                    <div className="blk-clr">
                      <label>{UserNameDisplay}</label>
                    </div>
                  </div>
                  <hr />
                  {/*User Info*/}
                  <div className="field-wrapper field-box6">
                    {/*Prefix*/}
                    <label htmlFor="NamePrefix">Prefix</label>
                    <select
                      id="NamePrefix"
                      className="form-control"
                      name="NamePrefix"
                      onChange={(el) => setNamePrefix(el.target.value)}
                      value={NamePrefix}
                    >
                      <option value="">Select</option>
                      <option value="Prof">Prof</option>
                      <option value="Dr">Dr</option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Miss">Miss</option>
                    </select>
                  </div>
                  {/*First Name*/}
                  <div className="field-wrapper field-box2 sp-mx1">
                    <label htmlFor="FirstName">First Name</label>
                    <input
                      type="text"
                      id="FirstName"
                      className="form-control"
                      autoComplete="given-name"
                      value={FirstName}
                      onChange={(el) => setFirstName(el.target.value)}
                      disabled
                    />
                    {FirstName === "" && frmSubmFlag ? (
                      <div
                        className={`alert alert-danger`}
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        First name is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Last Name*/}
                  <div className="field-wrapper field-box2">
                    <label htmlFor="LastName">Last Name</label>
                    <input
                      id="LastName"
                      type="text"
                      className="form-control"
                      autoComplete="family-name"
                      value={LastName}
                      onChange={(el) => setLastName(el.target.value)}
                      disabled
                    />
                    {LastName === "" && frmSubmFlag ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        Last name is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Credential*/}
                  <div className="field-wrapper field-box3 w-md11">
                    <label htmlFor="Credential">Credential</label>
                    <input
                      className="form-control"
                      name="Credential"
                      id="Credential"
                      autoComplete="off"
                      placeholder="Optional"
                      value={Credential}
                      onChange={(el) => setCredential(el.target.value)}
                    />
                  </div>

                  {/*Contact Email*/}
                  <div className="field-wrapper">
                    <label htmlFor="ContactEmail">Contact Email</label>
                    <input
                      className="form-control"
                      name="ContactEmail"
                      id="ContactEmail"
                      autoComplete="email"
                      value={ContactEmail}
                      onChange={(el) => setContactEmail(el.target.value)}
                      required
                    />
                    {ContactEmail === "" && frmSubmFlag ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        Contact Email is required.
                      </div>
                    ) : null}
                    {invalidContactEmail && frmSubmFlag ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        Please enter a valid email name with more than 4
                        characters long, no spaces, commas, or special
                        characters.
                      </div>
                    ) : null}
                  </div>
                  {/*Address 1*/}
                  <div className="field-wrapper field-box2">
                    <label htmlFor="FirstLine">Address 1</label>
                    <input
                      className="form-control"
                      name="FirstLine"
                      id="FirstLine"
                      autoComplete="address-line1"
                      value={Addresses?.FirstLine}
                      onChange={(el) =>
                        setAnswer("FirstLine", el.target.value, true)
                      }
                    />
                    {isEmpty(Addresses?.FirstLine) && frmSubmFlag ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        Address is required.
                      </div>
                    ) : null}
                  </div>
                  {/*Address 2*/}
                  <div className="field-wrapper field-box3 w-md11">
                    <label htmlFor="SecondLine">Address 2</label>
                    <input
                      className="form-control"
                      name="SecondLine"
                      id="SecondLine"
                      autoComplete="address-line2"
                      placeholder="Optional"
                      value={Addresses?.SecondLine}
                      onChange={(el) =>
                        setAnswer("SecondLine", el.target.value, true)
                      }
                    />
                  </div>
                  {/*City*/}
                  <div className="field-wrapper">
                    <label htmlFor="City">City</label>
                    <input
                      className="form-control"
                      name="City"
                      id="City"
                      autoComplete="address-level2"
                      value={Addresses?.City}
                      onChange={(el) =>
                        setAnswer("City", el.target.value, true)
                      }
                    />
                    {Addresses?.City === "" && frmSubmFlag ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        City is required.
                      </div>
                    ) : null}
                  </div>
                  <div className="field-wrapper">
                    {/*State*/}
                    <div className="field-box5">
                      <label htmlFor="account-details-state">State</label>
                      <select
                        className="form-control"
                        name="State"
                        id="account-details-state"
                        value={Addresses?.State}
                        onChange={(el) =>
                          setAnswer("State", el.target.value, true)
                        }
                      >
                        <option value={""}>Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/*PostalCode Code*/}
                    <div className="org-contact-wrapper field-ext">
                      <label htmlFor="PostalCode">Zip</label>
                      <input
                        className="form-control"
                        id="PostalCode"
                        name="PostalCode"
                        autoComplete="postal-code"
                        maxLength={5}
                        value={Addresses?.PostalCode}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                          setAnswer("PostalCode", onlyNums, true);
                        }}
                      />
                    </div>
                    {Addresses?.State === "" && frmSubmFlag ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        State is required.
                      </div>
                    ) : null}
                    {frmSubmFlag && isEmptyStr(Addresses?.PostalCode) ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        Zip Code is required.
                      </div>
                    ) : frmSubmFlag &&
                      isInvalidPostalCode(Addresses?.PostalCode) ? (
                      <div
                        className="alert alert-danger"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                      >
                        Invalid Zip Code
                      </div>
                    ) : null}
                  </div>
                  {/*Phone*/}
                  <div className="field-wrapper ">
                    <div className="field-box1 text-robo-reg">
                      <label htmlFor="Phone">Phone</label>
                      <input
                        className="form-control"
                        id="Phone"
                        name="Phone"
                        autoComplete="tel"
                        // keep state as digits-only, show formatted
                        value={formatPhoneNumber(getDigits(Addresses?.Phone))}
                        onChange={(e) => {
                          const digits = getDigits(e.target.value).slice(0, 10);
                          setAnswer("Phone", digits, true);
                        }}
                      />

                      {frmSubmFlag && isEmptyStr(Addresses?.Phone) ? (
                        <div
                          className="alert alert-danger"
                          role="alert"
                          aria-live="assertive"
                          aria-atomic="true"
                        >
                          Phone number is required.
                        </div>
                      ) : frmSubmFlag && isInvalidPhone(Addresses?.Phone) ? (
                        <div
                          className="alert alert-danger"
                          role="alert"
                          aria-live="assertive"
                          aria-atomic="true"
                        >
                          Invalid Phone Number
                        </div>
                      ) : null}
                    </div>

                    <div className="spacer-inline field-ext v-top">
                      <label htmlFor="PhoneExt">Ext</label>
                      <input
                        className="form-control"
                        name="PhoneExt"
                        id="PhoneExt"
                        autoComplete="tel-extension"
                        value={Addresses?.PhoneExt}
                        maxLength={6}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                          setAnswer("PhoneExt", onlyNums, true);
                        }}
                      />
                    </div>
                  </div>

                  {/* Fax (optional) */}
                  <div className="field-wrapper">
                    <div className="field-box1 text-robo-reg">
                      <label htmlFor="Fax">Fax</label>
                      <input
                        className="form-control"
                        name="Fax"
                        id="Fax"
                        autoComplete="off"
                        placeholder="Optional"
                        value={formatPhoneNumber(getDigits(Addresses?.Fax))}
                        onChange={(el) => {
                          const digits = getDigits(el.target.value).slice(
                            0,
                            10,
                          );
                          setAnswer("Fax", digits, true);
                        }}
                      />
                      {frmSubmFlag &&
                      !isEmptyStr(Addresses?.Fax) &&
                      isInvalidPhone(Addresses?.Fax) ? (
                        <div
                          className="alert alert-danger"
                          role="alert"
                          aria-live="assertive"
                          aria-atomic="true"
                        >
                          Invalid Fax Number
                        </div>
                      ) : null}
                    </div>

                    <div className="spacer-inline field-ext v-top">
                      <label htmlFor="FaxExt">Ext</label>
                      <input
                        className="form-control"
                        name="FaxExt"
                        id="FaxExt"
                        autoComplete="off"
                        maxLength={6}
                        value={Addresses?.FaxExt}
                        disabled={getDigits(Addresses?.Fax).length === 0}
                        onChange={(el) => {
                          const onlyNums = el.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                          setAnswer("FaxExt", onlyNums, true);
                        }}
                      />
                    </div>
                  </div>
                  {userRole !== "SES ADMINISTRATOR" &&
                  userRole !== "SYSTEMADMINISTRATOR" ? (
                    <>
                      {/* Specialty */}
                      <div className="field-wrapper label-divider">
                        <h6 className="sp-pad9">Specialty</h6>
                      </div>

                      <div className="field-wrapper text-reg">
                        If you select a type, then you must select both
                        classification and specialization.
                      </div>

                      <div className="field-wrapper">
                        <SpecialtyDropdown
                          SpecialFormFields={(el, val) =>
                            SpecialFormFields(el, val)
                          }
                          editObj={specialtiesObj}
                        />
                      </div>

                      {specialtiesFlag && frmSubmFlag && (
                        <div
                          className="alert alert-danger"
                          id="SpecialtyId"
                          role="alert"
                          aria-live="assertive"
                          aria-atomic="true"
                        >
                          Specialization is required when you are selecting Type
                          or Classification.
                        </div>
                      )}
                    </>
                  ) : null}
                  {/*Permissions - Admin Use Only*/}
                  {/*{sharedObject.hidePermission ? null : (*/}
                  {/*  <div>*/}
                  {/*    <div className="field-wrapper label-divider">*/}
                  {/*      <div className="sp-margin7 spacer-inline sp-margin17">*/}
                  {/*        Permissions*/}
                  {/*      </div>*/}
                  {/*    </div>*/}
                  {/*    <div className="field-wrapper">*/}
                  {/*      <input*/}
                  {/*        type="checkbox"*/}
                  {/*        className="spacer-margin5"*/}
                  {/*        id="TwoFactorEnabled"*/}
                  {/*        value={answers?.TwoFactorEnabled}*/}
                  {/*        checked={answers?.TwoFactorEnabled}*/}
                  {/*        onChange={(el) =>*/}
                  {/*          setAnswer("TwoFactorEnabled", el.target.checked)*/}
                  {/*        }*/}
                  {/*      />*/}
                  {/*      <label className="spacer-margin8">*/}
                  {/*        Two Factor Authentication*/}
                  {/*      </label>*/}
                  {/*      <div className="sub-catg">*/}
                  {/*        In order to activate Two-Factor Authentication for*/}
                  {/*        this user, the checkbox must be checked to enable new*/}
                  {/*        authentication code setting.*/}
                  {/*      </div>*/}
                  {/*    </div>*/}
                  {/*  </div>*/}
                  {/*)}*/}
                </div>

                {flag === "success" ? (
                  <div
                    className="alert alert-success"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                  >
                    User profile has been updated successfully.
                  </div>
                ) : null}
                {flag === "error" ? (
                  <div
                    className="alert alert-danger"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                  >
                    We cannot save your settings at this time. If the problem
                    persists please contact your administrator.
                  </div>
                ) : null}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={updateUser}
                  aria-label="Update user account"
                  aria-busy={processing}
                  disabled={processing}
                >
                  {processing ? "Updating..." : "Update"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  disabled={processing}
                  onClick={(e) => {
                    CloseModal();
                    ClearFields();
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {processing && (
        <div
          className="loader-container"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          aria-labelledby="account-details-loader"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="account-details-loader">
            {loadingText}
          </div>
        </div>
      )}
    </div>
  );
};

export default EditUser;
